import Typography from "components/common/Typography";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";
import { ROUTE_PATHS } from "const/paths";
import { useLocation, useParams } from "react-router-dom";

import EventForm from "../RecuringEventForm";

import { useRecuringEventForm } from "./hooks";

const NewRecuringEvent: FC = () => {
  const eventForm = useRecuringEventForm();

  const location = useLocation();

  const isRecurringEventDetails = location.pathname.includes(
    ROUTE_PATHS.RecuringEventDetails.replace(":id", "")
  );

  const isRecurringEventCreate = location.pathname.includes(
    ROUTE_PATHS.RecuringEventCreate.replace(":type", "")
  );

  const params = useParams<{ id?: string; type?: string }>();

  const templateId = params.id ? parseInt(params.id, 10) : undefined;

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Create recurring event" />
        </Typography.Title>
      </Header>
      <EventForm
        isRecurringEventCreate={isRecurringEventCreate}
        isRecurringEventDetails={isRecurringEventDetails}
        templateId={templateId}
        {...eventForm}
      />
    </>
  );
};

export default NewRecuringEvent;
